import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import EkycNotice from './components/ekyc-notice.vue';
import ScanGift from './components/scan-gift-module/index.vue';
import NewUserInfo from './components/new-user-info.vue';
import { isReturningHKUser } from '@/api';
import { to } from '@tencent/wphk-base-utils';
import { i18n } from '@/i18n';
/** 判断扫码有礼部分是否初始化ready */

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isScanGiftReady = ref(false);
/** 判断新人专区部分是否初始化ready */
const isNewUserZoneReady = ref(false);
/** 是否展示整体模块 */
const isModuleReady = computed(() => isScanGiftReady.value && isNewUserZoneReady.value);
/** 是否展示新人专区 */
const isShowNewUserZone = ref(false);

const handleScanGiftReady = () => {
  isScanGiftReady.value = true;
};
onMounted(async () => {
  const [err, result] = await to(isReturningHKUser());
  isNewUserZoneReady.value = true;
  if (err || !result) return;
  isShowNewUserZone.value = true;
});


return { __sfc: true,isScanGiftReady, isNewUserZoneReady, isModuleReady, isShowNewUserZone, handleScanGiftReady, EkycNotice, ScanGift, NewUserInfo, i18n }
}

})